/**
 * LifeRamp
 *
 * @author      Waris Anwar
 * @copyright   LifeRamp Inc.
 *
 * Built by Eonyx Infotech LLP.
 * @link https://eonyx.io
 *
 */

export const Licenses = [
    {
        name: "@afaanbilal/random-string",
        copyright: "Copyright (c) 2021 Afaan Bilal",
        url: "https://raw.githubusercontent.com/AfaanBilal/random-string/master/LICENSE",
        license: "MIT",
    },
    {
        name: "babel/core",
        copyright: "Copyright (c) 2014-present Sebastian McKenzie and other contributors",
        url: "https://raw.githubusercontent.com/babel/babel/main/LICENSE",
        license: "MIT",
    },
    {
        name: "reduxjs/toolkit",
        copyright: "Copyright (c) 2018 Mark Erikson",
        url: "https://raw.githubusercontent.com/reduxjs/redux-toolkit/master/LICENSE",
        license: "MIT",
    },
    {
        name: "axios",
        copyright: "Copyright (c) 2014-present Matt Zabriskie",
        url: "https://raw.githubusercontent.com/axios/axios/master/LICENSE",
        license: "MIT",
    },
    {
        name: "bootstrap",
        copyright: "Copyright (c) 2011-2021 Twitter, Inc.",
        url: "https://raw.githubusercontent.com/twbs/bootstrap/main/LICENSE",
        license: "MIT",
    },
    {
        name: "chart.js",
        copyright: "Copyright (c) 2014-2021 Chart.js Contributors",
        url: "https://github.com/chartjs/Chart.js/raw/master/LICENSE.md",
        license: "MIT",
    },
    {
        name: "jquery",
        copyright: "https://github.com/jquery/jquery/raw/main/LICENSE.txt",
        url: "Copyright ©  OpenJS Foundation and other contributors",
        license: "MIT",
    },
    {
        name: "node-sass",
        copyright: "Copyright (c) 2013-2016 Andrew Nesbitt",
        url: "https://github.com/sass/node-sass/raw/master/LICENSE",
        license: "MIT",
    },
    {
        name: "perfect-scrollbar",
        copyright: "Copyright (c) 2012-2019 Hyunje Jun, MDBootstrap.com and other contributors",
        url: "https://github.com/mdbootstrap/perfect-scrollbar/raw/master/LICENSE",
        license: "MIT",
    },
    {
        name: "react",
        copyright: "Copyright (c) Facebook, Inc. and its affiliates.",
        url: "https://raw.githubusercontent.com/facebook/react/main/LICENSE",
        license: "MIT",
    },
    {
        name: "react-dom",
        copyright: "Copyright (c) 2015-present Dan Abramov",
        url: "https://raw.githubusercontent.com/reduxjs/react-redux/master/LICENSE.md",
        license: "MIT",
    },
    {
        name: "react-router, react-router-dom",
        copyright: "Copyright (c) React Training 2016-2018",
        url: "https://github.com/ReactTraining/react-router/raw/master/LICENSE",
        license: "MIT",
    },
    {
        name: "react-scripts",
        copyright: "Copyright (c) 2013-present, Facebook, Inc.",
        url: "https://github.com/facebook/create-react-app/raw/master/LICENSE",
        license: "MIT",
    },
    {
        name: "reactstrap",
        copyright: "Copyright (c) 2016-Present Eddy Hernandez, Chris Burrell, Evan Sharp",
        url: "https://github.com/reactstrap/reactstrap/raw/master/LICENSE",
        license: "MIT",
    },
    {
        name: "react-notification-alert",
        copyright: "Copyright (c) 2020 Creative Tim",
        url: "https://github.com/creativetimofficial/react-notification-alert/raw/main/LICENSE.md",
        license: "MIT",
    },
    {
        name: "react-image-crop",
        copyright: "Copyright (c) 2015, Dominic Tobias",
        url: "https://github.com/DominicTobias/react-image-crop/raw/master/LICENSE.md",
        license: "MIT",
    },
    {
        name: "react-chartjs-2",
        copyright: "Copyright (c) 2017 Jeremy Ayerst",
        url: "https://github.com/reactchartjs/react-chartjs-2/raw/master/LICENSE.md",
        license: "MIT",
    },
];
